import router from '@/modules/myInvoices/router'
import { useMyInvoicesStore } from '@/modules/myInvoices/store'
import MyInvoicesApi from '@/modules/myInvoices/service'

export default {
  router,
  service: new MyInvoicesApi(),
  store: useMyInvoicesStore,
}
